export const MONITORINGS_GET = 'MONITORINGS_GET';
export const MONITORING_GET = 'MONITORING_GET';
export const MONITORINGSTUDENTS_GET = 'MONITORINGSTUDENTS_GET';
export const MONITORINGSTUDENT_GET = 'MONITORINGSTUDENT_GET';
export const MONITORING_FILTER = 'MONITORING_FILTER';